import React from 'react'
import { Route, Redirect } from 'react-router-dom'
import * as authService from '../services/auth'

const PrivateRoute = ({ component: Component, ...rest }) => {
  return (
    <Route
      {...rest}
      render={props => {
        if (!authService.getAccessToken()) {
          return <Redirect to={{ pathname: '/login', state: { from: props.location } }} />
        }
        return <Component {...props} isAuthorized={rest.isAuthorized} />
      }}
    />
  )
}
export default PrivateRoute
